export class SerialPort {
    // 获取可用串口列表
    static getPorts = async () => {
        try {
            const availablePorts = await window.serialport.list();
            console.log('可用串口:', availablePorts);
            return availablePorts;
        } catch (error) {
            console.error('获取串口列表失败:', error);
            return [];
        }
    };

    // 连接串口
    static connectPort = async (selectedPort, baudRate) => {
        if (!selectedPort) {
            alert( '请选择串口');
            return;
        }

        try {
            const port = await window.serialport.createPort(selectedPort, {
                baudRate: baudRate,
                dataBits: 8,
                parity: 'none',
                stopBits: 1
            });

            // 监听数据
            port.on('data', (data) => {
                console.log('接收到数据:', data);
            });

            return{
                port: port,
                connectStatus: 1
            }
        } catch (error) {
            console.error('连接串口失败:', error);
            return {
                error: error,
                connectStatus: 0
            }
        }
    };

    // 断开串口
    static disconnectPort = async (port: any) => {
        if (port) {
            try {
                await port.close();
                port = null;
                return {
                    connectStatus: 1
                }
            } catch (error) {
                return{
                    error: error,
                    connectStatus: 0
                }
            }
        }
    };

    // 发送数据
    static sendData = async (data, port) => {
        try {
            await port.write(data);
        } catch (error) {
            console.error('发送数据失败:', error);
        }
    };

    // 读取数据 - 修复后的方法
    static readSerialData = async (port, timeout = 1000) => {
        let receivedData = '';
        let hexString;
        try {
            const timeoutPromise = new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({ isTimeout: true });
                }, timeout)
            });
            let index = 0;
            while (true) {
                console.log('index:' + index);
                const readPromise = new Promise((resolve, reject) => {
                    port.readData(timeout)
                        .then(orValue => {
                            console.log('orValue:', orValue);
                            // 直接传递包含 value 和 done 的对象给 resolve
                            const done = orValue === null;
                            resolve({
                                value: orValue,
                                done,
                                isTimeout: false
                            });
                        })
                        .catch(reject); // 传递读取失败的错误
                });
                const { value, done, isTimeout } = await Promise.race([readPromise, timeoutPromise]);
                if (done) {break;}
                if (isTimeout) {
                    console.log('单次读取超时，返回已接收数据');
                    break; // 跳出循环，结束读取
                }
                if (value != undefined) {
                    if (receivedData.length == 0) {
                        receivedData = value;
                    } else {
                        receivedData = receivedData + "," + value;
                    }
                } else {
                    break;
                }
                if (index > 30) {break;}
                index = index + 1;
            }
        } catch (error) {
            console.error('读取数据失败:', error);
        } finally {
            hexString = SerialPort.convertToHexString(receivedData)
        }
        console.log('hex:' + hexString)
        return hexString;
    };

    // 读取指定长度的数据
    static readLengthData = async (port, length, timeout = 1000) => {
        try {
            const data = await port.readLength(length, timeout);
            const hexString = data.toString('hex');
            console.log(`读取${length}字节数据(hex):`, hexString);
            return hexString;
        } catch (error) {
            console.error('读取数据失败:', error);
            alert('读取数据失败: ' + error.message);
            return '';
        }
    };

    // 读取直到特定结束符
    static readUntilData = async (port, delimiter, timeout = 1000) => {
        try {
            const data = await port.readUntil(delimiter, timeout);
            const hexString = data.toString('hex');
            console.log(`读取到结束符${delimiter}的数据(hex):`, hexString);
            return hexString;
        } catch (error) {
            console.error('读取数据失败:', error);
            alert('读取数据失败: ' + error.message);
            return '';
        }
    };

    // 转换数据为十六进制字符串
    static convertToHexString = (data) => {
        data = data + "";
        if (!data.includes(',')) {
            return parseInt(data).toString(16);
        }
        const list = data.split(',').map(Number);
        let hex = list.map(byte => byte.toString(16).padStart(2, '0')).join(' ');
        return hex;
    };
}
